(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-section"] && !Shopify.designMode) return;
  try {
    
  const compresion_block = document.getElementById('comparison-table-w');
  const compresion_scrollText = document.getElementById('scroll_text');

  if (compresion_block && compresion_scrollText) {
    window.addEventListener('load', onLoadFunction);
    window.addEventListener('resize', onLoadFunction);
  }

  function onLoadFunction(e) {
    if (!compresion_block || !compresion_scrollText) return;
    let compresion_isHorizontalScroll = compresion_block.scrollWidth > compresion_block.clientWidth;
    compresion_isHorizontalScroll
      ? compresion_scrollText.classList.add('scroll-on')
      : compresion_scrollText.classList.remove('scroll-on');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactus"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.querySelector('#ContactForm');
    if (!contactForm) return;

    const nameInput = contactForm.querySelector('input[name="contact[name]"]');
    const emailInput = contactForm.querySelector('input[name="contact[email]"]');
    const submitBtn = contactForm.querySelector('.submit-button');

    if (!nameInput || !emailInput || !submitBtn) return;

    // Initially disable submit
    submitBtn.disabled = true;

    const validateForm = () => {
      const nameValid = nameInput.value.trim().length > 0;
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
      submitBtn.disabled = !(nameValid && emailValid);
    };

    // Listen for input changes
    nameInput.addEventListener('input', validateForm);
    emailInput.addEventListener('input', validateForm);

    // Optionally, prevent submission if JS disabled somehow
    contactForm.addEventListener('submit', (e) => {
      if (submitBtn.disabled) e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.refBlock && !this.dataset.behavior) return;
      const stickyHide = () => {
        this.setAttribute('data-revealed', false);
        if (this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if (this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if (this.height) {
          this.style.removeProperty('height');
          if (this.dataset.bodyClass) document.body.style.removeProperty('--page-header-height');
        }
      };
      const initialize = () => {
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        if (this.behavior) {
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', onStackedScroll.bind(this));
              break;
            case 'observer':
              window.addEventListener('scroll', onObservedScroll.bind(this));
              break;
            default:
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if (!this.refBlock) return;
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        if (this.spacer) this.height = this.refBlock.offsetHeight;
      };
      const onObservedScroll = () => {
        let revealedAttr = true;
        const handleObserver = (entries, observer) => {
          observer.unobserve(this);
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealedAttr = false;
            } else {
              revealedAttr = true;
            }
            setStickyStatus(revealedAttr);
          });
        };
        new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
      };
      const onDownwardScroll = () => {
        let revealedAttr = false;
        if (this.percent) {
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = (pageHeight * parseFloat(this.percent)) / 100;
          this.threshold = threshold;
        }
        if (window.scrollY > this.threshold) revealedAttr = true;
        setStickyStatus(revealedAttr);
      };
      const onUpwardScroll = () => {
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;

        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          if (window.scrollY < threshold) revealedAttr = false;
        }
        setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      };
      const onStackedScroll = () => {
        let revealedAttr = false;
        if (this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if (this.refBoundings.y < window.scrollY) revealedAttr = true;
        setStickyStatus(revealedAttr);
      };
      const setStickyStatus = (revealed) => {
        if (this.dataset.hideOnEnd === 'true')
          if (window.innerHeight + window.scrollY >= this.endBounds) return stickyHide();
        if (revealed) {
          this.setAttribute('data-revealed', true);
          if (this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if (this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if (this.height) {
            this.style.height = this.height + 'px';
            if (this.dataset.bodyClass) document.body.style.setProperty('--page-header-height', this.height + 'px');
          }
          return;
        }
        stickyHide();
      };
      const setTempoStatus = (flag, refContainer) => {
        const refElement = document.querySelector(refContainer);
        if (!refElement) return;
        refElement.style.transform = flag ? 'translateY(0%)' : 'translateY(-100%)';
      };
      this.setTempoStatus = setTempoStatus;
      this.setStickyStatus = setStickyStatus;
      this.initLoad = setTimeout(initialize.bind(this), 100);
      document.addEventListener('DOMContentLoaded', function () {
        this.initLoad;
      });
    }
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', StickyBlock);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const updateHeaderHeight = () => {
      const announcementBars = document.querySelectorAll('.announcement-bar');
      const pageHeader = document.querySelector('.page-header');
      let totalHeight = 0;
      announcementBars.forEach((bar) => {
        totalHeight += bar.offsetHeight || 0;
      });

      if (pageHeader) {
        totalHeight += pageHeader.offsetHeight || 0;
      }
      document.body.style.setProperty('--header-total-height', `${totalHeight}px`);
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    const observer = new MutationObserver(updateHeaderHeight);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) return new URLSearchParams(url.searchParams).toString();
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          if (!value) {
            url.searchParams.delete(param);
          } else {
            const valToDel = value;
            const values = url.searchParams.getAll(param);
            const updatedValues = values.filter((value) => value !== valToDel);
            url.searchParams.delete(param);
            updatedValues.forEach((value) => url.searchParams.append(param, value));
          }
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;

      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }

    input.value = url.toString();
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  class FiltersDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.querySelectorAll('input');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        this.initFilters();
        if (this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        closeDetailsTag();
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.fields.forEach((field) => {
          field.removeEventListener('input', this.debouncedOnSubmit.bind(this));
        });
        if (this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const closeDetailsTag = () => {
        const tags = this.querySelectorAll('details');
        tags.forEach((tag) => {
          tag.removeAttribute('open');
        });
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }

    initFilters() {
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 300);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;
      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
  }
  if (!customElements.get('filters-dropdown')) {
    customElements.define('filters-dropdown', FiltersDropdown);
  }
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-sort]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        self.closeDropdown();
      };
      const onSortSelect = (event) => {
        const target = event.target;
        self.items.forEach((item) =>
          item.classList.remove('main-featured-product-grid_facets-sort-action-btn--active')
        );
        target.classList.add('main-featured-product-grid_facets-sort-action-btn--active');
        setCurrentValue(target);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach((item) => {
          item.addEventListener('click', self.sortSelect);
        });
        if (this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => {
          item.removeEventListener('click', self.sortSelect);
        });
        if (this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.sortSelect = onSortSelect.bind(this);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) {
    customElements.define('sort-dropdown', SortDropdown);
  }

  class FacetRemoveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        const { name, value, valueArr } = this.dataset;
        const values = valueArr || value || null;

        setFilterParam(name === 'all' ? null : name, values, name === 'all' ? 'all' : true);

        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter?.onSubmitHandler?.();
      });
    }
  }

  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);

  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          if (updateURLHash) this.updateURLHash(searchParams);
          const filtersDropdown = document.querySelector('filters-dropdown');
          // Only toggle filter drawer if it's already open (to close it), not when sorting
          if (
            filtersDropdown &&
            filtersDropdown.button &&
            filtersDropdown.button.getAttribute('aria-expanded') === 'true'
          ) {
            filtersDropdown.button.dispatchEvent(new Event('click'));
          }
          if (target) this.handleDropdown(target);
          toggleLoader(false);
          window.mcpgInitCombinedListingCards?.();
          window.mcpgInitJudgeMeBadges?.();
          window.mcpgReplayCardEntrance?.();
        });
    }

    handleDropdown(target) {
      const org = document.getElementById(target);
      const dropdown = org.closest('details');
      dropdown.setAttribute('open', '');
      org.focus();
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      toggleLoader(false);
      window.mcpgInitCombinedListingCards?.();
      window.mcpgInitJudgeMeBadges?.();
      window.mcpgReplayCardEntrance?.();
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);

  const mcpgInitJudgeMeBadges = () => {
    if (typeof window.jdgm?.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
  };

  const mcpgReplayCardEntrance = (root = document) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.main-featured-product-grid .product-item').forEach((card) => {
      card.style.animation = 'none';
      card.offsetHeight;
      card.style.animation = '';
    });
  };

  /** Combined-listing cards: Liquid only resolves one child per card (all_products cap). */
  const mcpgChildProductImageCache = new Map();

  const mcpgCoerceChildProductImages = (productJson) => {
    if (!productJson) return null;
    const featured = productJson.featured_image || productJson.images?.[0] || '';
    const hover = productJson.images?.[1] || '';
    if (!featured) return null;
    return { imageUrl: featured, hoverImageUrl: hover || '' };
  };

  const mcpgFetchChildProductImages = async (handle) => {
    const key = String(handle || '').trim();
    if (!key) return null;
    if (mcpgChildProductImageCache.has(key)) return mcpgChildProductImageCache.get(key);
    const root = window.Shopify?.routes?.root || '/';
    try {
      const res = await fetch(`${root}products/${encodeURIComponent(key)}.js`, {
        credentials: 'same-origin'
      });
      if (!res.ok) {
        mcpgChildProductImageCache.set(key, null);
        return null;
      }
      const data = await res.json();
      const entry = mcpgCoerceChildProductImages(data);
      mcpgChildProductImageCache.set(key, entry);
      return entry;
    } catch {
      mcpgChildProductImageCache.set(key, null);
      return null;
    }
  };

  const mcpgApplyChildImagesToSwatch = (swatch, entry) => {
    if (!swatch || !entry?.imageUrl) return;
    if (!swatch.dataset.imageUrl) swatch.dataset.imageUrl = entry.imageUrl;
    if (!swatch.dataset.hoverImageUrl && entry.hoverImageUrl) {
      swatch.dataset.hoverImageUrl = entry.hoverImageUrl;
    }
  };

  const mcpgHydrateCombinedListingSwatchImages = async (scopeRoot = document) => {
    const swatches = scopeRoot.querySelectorAll(
      '.mcpg-card-swatches[data-swatch-source="combined-listing"] .mcpg-card-swatch[data-product-handle]'
    );
    if (!swatches.length) return;

    const handles = new Set();
    swatches.forEach((swatch) => {
      if (!swatch.dataset.imageUrl && swatch.dataset.productHandle) {
        handles.add(swatch.dataset.productHandle);
      }
    });
    if (!handles.size) return;

    await Promise.all([...handles].map((handle) => mcpgFetchChildProductImages(handle)));

    swatches.forEach((swatch) => {
      const entry = mcpgChildProductImageCache.get(swatch.dataset.productHandle);
      mcpgApplyChildImagesToSwatch(swatch, entry);
    });
  };

  const mcpgEnsureSwatchImages = async (swatch) => {
    if (!swatch || swatch.dataset.imageUrl || !swatch.dataset.productHandle) return;
    const entry = await mcpgFetchChildProductImages(swatch.dataset.productHandle);
    mcpgApplyChildImagesToSwatch(swatch, entry);
  };

  const mcpgBuildCombinedListingPdpUrl = (swatch, card) => {
    if (!swatch) return '';
    if (swatch.dataset.pdpUrl) return swatch.dataset.pdpUrl;
    const parentUrl =
      swatch.dataset.parentUrl || card?.dataset?.parentUrl || card?.querySelector('.mcpg-card-swatches')?.dataset?.parentUrl;
    const optionValueId = swatch.dataset.optionValueId;
    const variantId = swatch.dataset.variantId;
    if (!parentUrl || !optionValueId) return parentUrl || '';
    try {
      const u = new URL(parentUrl, window.location.origin);
      u.searchParams.set('option_values', optionValueId);
      if (variantId) u.searchParams.set('variant', variantId);
      return `${u.pathname}${u.search}`;
    } catch {
      return parentUrl;
    }
  };

  const mcpgApplyCardImages = (card, primaryUrl, hoverUrl) => {
    const primary = card.querySelector('.primary-image');
    const secondary = card.querySelector('.secondary-image');
    if (primary && primaryUrl) {
      primary.src = primaryUrl;
      primary.removeAttribute('srcset');
      primary.removeAttribute('sizes');
    }
    if (secondary && hoverUrl) {
      secondary.src = hoverUrl;
      secondary.removeAttribute('srcset');
      secondary.removeAttribute('sizes');
    }
  };

  const mcpgPaintCardSwatch = (card, swatch) => {
    if (!card || !swatch) return;
    const primaryUrl = swatch.dataset.imageUrl || '';
    const hoverUrl = swatch.dataset.hoverImageUrl || '';
    if (!primaryUrl && swatch.dataset.productHandle) {
      void mcpgEnsureSwatchImages(swatch).then(() => {
        if (swatch.dataset.imageUrl) mcpgApplyCardImages(card, swatch.dataset.imageUrl, swatch.dataset.hoverImageUrl || '');
      });
      return;
    }
    mcpgApplyCardImages(card, primaryUrl, hoverUrl);
  };

  const mcpgGetActiveSwatch = (card) => card.querySelector('.mcpg-card-swatch.active');

  const mcpgMoveActiveSwatchFirst = (wrap, swatch) => {
    if (!wrap || !swatch) return;
    const first = wrap.querySelector('.mcpg-card-swatch');
    if (first && first !== swatch) {
      wrap.insertBefore(swatch, first);
    }
  };

  const mcpgApplyCardUrl = (card, url) => {
    if (!card || !url) return;
    card.dataset.cardUrl = url;
    const imageLink = card.querySelector('.mcpg-card-image-link');
    if (imageLink) imageLink.href = url;
    const titleLink = card.querySelector('.mcpg-card-title-link');
    if (titleLink) titleLink.href = url;
    card.querySelectorAll('.mcpg-card-swatch-more').forEach((link) => {
      link.href = url;
    });
    const btn = card.querySelector('.product-item_bottom-wrap .btn');
    if (btn) btn.setAttribute('onclick', `location.href='${url}'`);
  };

  const mcpgUpdateCardLinks = (card, swatch) => {
    if (!card || !swatch) return;
    const wrap = card.querySelector('.mcpg-card-swatches');
    const mode = wrap?.dataset?.swatchSource || card.dataset.swatchSource || '';
    let url = swatch.dataset.pdpUrl || '';
    if (!url && mode === 'combined-listing') {
      url = mcpgBuildCombinedListingPdpUrl(swatch, card);
    }
    if (
      !url &&
      (mode === 'custom-options' || mode === 'pdp-customizer-background') &&
      swatch.dataset.colorName
    ) {
      try {
        const base = (card.dataset.cardUrl || window.location.pathname).split('?')[0];
        url = `${base}?background=${encodeURIComponent(swatch.dataset.colorName)}`;
      } catch {
        url = '';
      }
    }
    if (!url) url = card.dataset.cardUrl || '';
    if (!url) return;
    mcpgApplyCardUrl(card, url);
  };

  const mcpgCommitCardSwatch = (card, swatch) => {
    const wrap = swatch.closest('.mcpg-card-swatches');
    if (!wrap) return;
    wrap.querySelectorAll('.mcpg-card-swatch').forEach((el) => {
      el.classList.remove('active');
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('active');
    swatch.setAttribute('aria-pressed', 'true');
    mcpgMoveActiveSwatchFirst(wrap, swatch);
    mcpgUpdateCardLinks(card, swatch);
    mcpgPaintCardSwatch(card, swatch);
  };

  // Capture the server-rendered (parent PDP) image so we can return to it when no color is selected.
  const mcpgCaptureRestImages = (card) => {
    ['primary-image', 'secondary-image'].forEach((cls) => {
      const img = card.querySelector('.' + cls);
      if (img && img.dataset.restCaptured !== 'true') {
        img.dataset.restSrc = img.getAttribute('src') || '';
        img.dataset.restSrcset = img.getAttribute('srcset') || '';
        img.dataset.restSizes = img.getAttribute('sizes') || '';
        img.dataset.restCaptured = 'true';
      }
    });
  };

  const mcpgRestoreRestImages = (card) => {
    ['primary-image', 'secondary-image'].forEach((cls) => {
      const img = card.querySelector('.' + cls);
      if (!img || img.dataset.restCaptured !== 'true') return;
      if (img.dataset.restSrc) img.src = img.dataset.restSrc;
      if (img.dataset.restSrcset) {
        img.setAttribute('srcset', img.dataset.restSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (img.dataset.restSizes) {
        img.setAttribute('sizes', img.dataset.restSizes);
      } else {
        img.removeAttribute('sizes');
      }
    });
  };

  const mcpgClearCardSelection = (card) => {
    card.querySelectorAll('.mcpg-card-swatch').forEach((el) => {
      el.classList.remove('active');
      el.setAttribute('aria-pressed', 'false');
    });
  };

  const mcpgInitCombinedListingCards = async () => {
    await mcpgHydrateCombinedListingSwatchImages();
    document.querySelectorAll('.product-item--has-swatches').forEach((card) => {
      // Default resting state: no swatch pre-selected and the card shows the parent PDP first
      // image (rendered server-side). The card links point at the parent PDP with the first
      // color's option_values, so opening it auto-selects the first color. A color is selected
      // on the card only when the shopper clicks a swatch (mcpgCommitCardSwatch), which repaints
      // the image and points the card at that variant's PDP.
      mcpgCaptureRestImages(card);
      mcpgClearCardSelection(card);
      mcpgRestoreRestImages(card);
      const wrap = card.querySelector('.mcpg-card-swatches');
      // Default (no swatch clicked): point the card at the BARE parent PDP url (strip the
      // first color's ?option_values) so a plain card click opens the parent shell with NO
      // color pre-selected. option_values is only added when the shopper clicks a swatch
      // (mcpgCommitCardSwatch → mcpgUpdateCardLinks).
      const initialUrl = wrap && wrap.dataset ? wrap.dataset.initialPdpUrl : '';
      const bareUrl = initialUrl ? initialUrl.split('?')[0] : '';
      if (bareUrl) mcpgApplyCardUrl(card, bareUrl);
    });
  };

  const mcpgBootCombinedListingCards = () => {
    void mcpgInitCombinedListingCards();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      mcpgBootCombinedListingCards();
      mcpgInitJudgeMeBadges();
    });
  } else {
    mcpgBootCombinedListingCards();
    mcpgInitJudgeMeBadges();
  }
  window.mcpgInitCombinedListingCards = mcpgBootCombinedListingCards;
  window.mcpgInitJudgeMeBadges = mcpgInitJudgeMeBadges;
  window.mcpgReplayCardEntrance = mcpgReplayCardEntrance;

  document.addEventListener(
    'mouseenter',
    (event) => {
      // `mouseenter` fires on `document` when the pointer enters the viewport; then
      // `event.target` is the document, which has no `.closest` — guard before calling it.
      if (!(event.target instanceof Element)) return;
      const swatch = event.target.closest('.mcpg-card-swatch');
      if (!swatch) return;
      const card = swatch.closest('.product-item--has-swatches');
      if (!card) return;
      mcpgCaptureRestImages(card);
      mcpgPaintCardSwatch(card, swatch);
    },
    true
  );

  document.addEventListener('focusin', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('.mcpg-card-swatch');
    if (!swatch) return;
    const card = swatch.closest('.product-item--has-swatches');
    if (card) mcpgPaintCardSwatch(card, swatch);
  });

  document.addEventListener('mouseleave', (event) => {
    // `mouseleave` fires on `document` when the pointer leaves the viewport; `event.target`
    // is then the document (no `.closest`). Guard so it no-ops instead of throwing.
    if (!(event.target instanceof Element)) return;
    const wrap = event.target.closest('.mcpg-card-swatches');
    if (!wrap || wrap.contains(event.relatedTarget)) return;
    const card = wrap.closest('.product-item--has-swatches');
    if (!card) return;
    const active = mcpgGetActiveSwatch(card);
    if (active) {
      mcpgPaintCardSwatch(card, active);
    } else {
      mcpgRestoreRestImages(card);
    }
  });

  document.addEventListener('focusout', (event) => {
    if (!(event.target instanceof Element)) return;
    const wrap = event.target.closest('.mcpg-card-swatches');
    if (!wrap || wrap.contains(event.relatedTarget)) return;
    const card = wrap.closest('.product-item--has-swatches');
    if (!card) return;
    const active = mcpgGetActiveSwatch(card);
    if (active) {
      mcpgPaintCardSwatch(card, active);
    } else {
      mcpgRestoreRestImages(card);
    }
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('.mcpg-card-swatch');
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest('.product-item--has-swatches');
      if (card) mcpgCommitCardSwatch(card, swatch);
      return;
    }
    const moreLink = event.target.closest('.mcpg-card-swatch-more');
    if (moreLink) {
      event.stopPropagation();
      return;
    }
    const imageLink = event.target.closest('.mcpg-card-image-link');
    if (imageLink) {
      event.stopPropagation();
      return;
    }
    const titleLink = event.target.closest('.mcpg-card-title-link');
    if (titleLink) {
      event.stopPropagation();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('.mcpg-card-swatch');
    if (!swatch) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest('.product-item--has-swatches');
      if (card) mcpgCommitCardSwatch(card, swatch);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search-results"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) return new URLSearchParams(url.searchParams).toString();
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach(key =>
            key.includes('filter.v.price') && url.searchParams.delete(key)
          );
        } else {
          if(!value){
            url.searchParams.delete(param);
          } else{
            const valToDel = value;
            const values = url.searchParams.getAll(param);
            const updatedValues = values.filter(value => value !== valToDel);
            url.searchParams.delete(param);
            updatedValues.forEach(value => url.searchParams.append(param, value));
          }
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach(key =>
          key.includes('filter') && url.searchParams.delete(key)
        );
        break;

      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }

    input.value = url.toString();
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  class FiltersDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.querySelectorAll('input');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)){
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        this.initFilters();
        if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        closeDetailsTag();
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.fields.forEach(field => {
          field.removeEventListener('input', this.debouncedOnSubmit.bind(this));
        });
        if(this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const closeDetailsTag = () => {
        const tags = this.querySelectorAll('details');
        tags.forEach(tag => {
          tag.removeAttribute('open');
        });
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }

    initFilters(){
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach(field => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }

    onSubmitHandler(event){
      event.preventDefault();
      const target = event.target;
      switch(target.type){
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
  }
  if (!customElements.get('filters-dropdown')) { customElements.define('filters-dropdown', FiltersDropdown); }
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-sort]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        self.closeDropdown();
      }
      const onSortSelect = (event) => {
        const target = event.target;
        self.items.forEach(item => item.classList.remove('main-featured-product-grid_facets-sort-action-btn--active'));
        target.classList.add('main-featured-product-grid_facets-sort-action-btn--active');
        setCurrentValue(target);
      }
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)){
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach(item => {item.addEventListener('click', self.sortSelect);});
        if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if(self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.items.forEach(item => {item.removeEventListener('click', self.sortSelect);});
        if(this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.sortSelect = onSortSelect.bind(this);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) { customElements.define('sort-dropdown', SortDropdown); }
  
  class FacetRemoveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        const { name, value, valueArr } = this.dataset;
        const values = valueArr || value || null;

        setFilterParam(name === 'all' ? null : name, values, name === 'all' ? 'all' : true);

        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter?.onSubmitHandler?.();
      });
    }
  }

  if (!customElements.get('facet-remove-button'))
    customElements.define('facet-remove-button', FacetRemoveButton);


  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback(){
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event){
      if(event.state && this.cachedResults.length === 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }
      
      if(this.cachedResults && this.cachedResults.length > 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
        if (this.cachedResults.some(key => key.params === term.params)) return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target){
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if(!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = {params: searchParams};
      if(this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)){
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null){
      fetch(url)
        .then(response => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach(section => {
            const html = new DOMParser() .parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach(selector => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = {params: searchParams, content: data};
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          if(updateURLHash) this.updateURLHash(searchParams);
          if(target){
            const org = document.getElementById(target);
            if(org) org.focus();
          }
          toggleLoader(false);
        }
      );
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach(section => {
        const html = new DOMParser() .parseFromString(cachedResults.content[section.id], 'text/html').getElementById(section.id);
        section.selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if(updateURLHash) this.updateURLHash(filter.params);
      toggleLoader(false);
    }

    updateURLHash(searchParams){
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState({ searchParams }, '', `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`);
    }
  }
  if(!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);

  } catch(e) { console.error(e); }
})();
})();
